import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AuthBackButton from "../../../components/backButton";
import GlobalButton from "../../../components/button";
import CodeInput from "../../../components/codeInput";
import AuthContainer from "../../../components/container/AuthContainer";
import { useSnackbar } from "../../../lib/context/snackbarContext";
import AppLoader from "../../../components/apploader";
import { registerUser, sendCodeUser } from "../../../services/authenticationFn";
import { encryptPassword } from "../../../utils";
import { t } from "i18next";

const RegistrationVerification = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showSnackbar } = useSnackbar();
  const [code, setCode] = useState();
  const [isLoaing, setIsLoading] = useState();

  const handleVerifyAndRegisterUser = async () => {
    if (!code) return showSnackbar(t("verificationCodeRequired"), "error");

    if (code.length < 6) return showSnackbar(t("invalidCode"), "error");

    try {
      const { inputValues } = state;

      const payload = {
        signupAs: inputValues.signupAs,
        firstname: inputValues.fname,
        lastname:
          inputValues.signupAs === "individual" ? inputValues.lname : "",
        email: inputValues.email,
        contact: inputValues.contact,
        profileImg: inputValues.image,
        password: encryptPassword(inputValues.password),
        role: "User",
        otp: code,
        cui: inputValues.signupAs === "business" ? inputValues.cui : "",
      };

      setIsLoading(true);
      const response = await registerUser(payload);
      if (response.data.status === "success") {
        showSnackbar(response.data.message, "success");
        navigate("/login");
      } else {
        showSnackbar(response.data.message, "error");
      }
    } catch (error) {
      showSnackbar(error.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendCode = async () => {
    try {
      const payload = {
        email: state?.inputValues?.email,
        purpose: "Registration",
        role: "User",
      };

      setIsLoading(true);
      const response = await sendCodeUser(payload);
      if (response.data.status === "success") {
        showSnackbar(response?.data?.message, "success");
      } else {
        showSnackbar(response?.data?.message, "error");
      }
    } catch (error) {
      showSnackbar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthContainer>
      <AppLoader isVisible={isLoaing} />
      <AuthBackButton
        handleClick={() =>
          navigate("/register", { state: { inputValues: state?.inputValues } })
        }
      />
      <Stack height={"400px"} justifyContent={"space-between"}>
        <Stack textAlign={"center"} mt={5}>
          <Typography variant="heading_pr" textTransform={"capitalize"}>
            {t("verificationProcess")}
          </Typography>
          <Typography variant="heading_sec">
            {t("messageSendInfo", {
              email: state?.inputValues?.email,
            })}
          </Typography>
        </Stack>
        <Stack alignItems={"center"}>
          <CodeInput code={code} setCode={setCode} />
          <Typography variant="heading_sec" mt={2}>
            {t("dontReceiveCode")}?{" "}
            <Typography
              component={"span"}
              color="primary"
              onClick={handleSendCode}
              sx={{
                textDecoration: "underline",
                cursor: "pointer",
                textTransform: "capitalize",
              }}
            >
              {t("resend")}
            </Typography>
          </Typography>
        </Stack>
        <GlobalButton
          btnText={"next"}
          handleClickBtn={handleVerifyAndRegisterUser}
          styleProps={{
            width: "100%",
            height: 50,
            mt: 4,
            fontSize: "1.125rem",
          }}
        />
      </Stack>
    </AuthContainer>
  );
};

export default RegistrationVerification;
